import { createFileRoute } from '@tanstack/react-router'
import { NestedReportPending } from './-components/shared/nested-report-pending'
import { ReportComponent } from './-components/report/report'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'
import { trpc } from '@/main'

export const Route = createFileRoute('/_app/employees/$employeeId/report')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    context.queryClient.prefetchQuery(trpc.employees.getEmployee.queryOptions(Number(params.employeeId)))
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: NestedReportPending,
  // Shown immediately: at the router's default pendingMs the NAV STACK cannot push while the loaders run,
  // because the level it would push is the route being rendered — see the full story in jobs.$jobId.report.
  pendingMs: 0,
  pendingMinMs: 0,
})

function RouteComponent() {
  return <ReportComponent />
}
